import React, { useState, useEffect } from "react";
import { Heading, Box } from "@chakra-ui/react";
import IssbContainer from "../IssbContainer";
import AIReviewSourcesPanel from "./AIReviewSourcesPanel";
import AIReviewQuestionsPanel from "./AIReviewQuestionsPanel";
import AIReviewRelaxPanel from "./AIReviewRelaxPanel";
import WizardStepWrapper from "../WizardStepWrapper";
import { postQuestionsAnswerJob } from "api/ai/ai.service";
import { useSelector } from "react-redux";
import { useQuery, useQueryClient } from "react-query";
import questionnaireService from "../../../api/issb/questionnaire.service";

const STEPS = ["SELECT_SOURCES", "SELECT_QUESTIONS", "RELAX"];

export default function AIReviewPage() {
  const [stepIndex, setStepIndex] = useState(0);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [sourceIds, setSourceIds] = useState([]);
  const [questionIds, setQuestionIds] = useState([]);
  const [sourceRoundIds, setSourceRoundIds] = useState([]);
  const [task, setTask] = useState(null);
  const roundSelector = useSelector((state) => state.issbRound);
  const questionnaireId = roundSelector.selectedRound.id;

  const queryClient = useQueryClient();

  const {data: questionnaireData} = useQuery(questionnaireId, () => questionnaireService.get(questionnaireId), {
    enabled: !!questionnaireId
  });
  useEffect(() => {
    setSourceRoundIds(questionnaireData?.sourceRoundIds);
  }, [questionnaireData]);

  const gotoNext = () => {
    // kick off the review?
    if (stepIndex === 1) {
      let fileinfoSpec = {
        other_fileinfo_ids: sourceIds,
        round_ids: sourceRoundIds
      };

      postQuestionsAnswerJob({ questionnaireId, questionIds, overwrite: "AI", draft: true, fileinfoSpec }).then(
        (task) => {
          setTask(task);
          queryClient.invalidateQueries("taskService.list");
        }
      );
    }
    setStepIndex(stepIndex + 1);
  };

  return (
    <IssbContainer>
      <Box mr="300px">
        <WizardStepWrapper
          nextText="Next"
          previousText="Previous"
          gotoNext={gotoNext}
          gotoPrevious={stepIndex === 2 ? false : () => setStepIndex(stepIndex - 1)}
          stepIndex={stepIndex}
          steps={STEPS}
          superTitle="AI Review"
          nextDisabled={nextDisabled}
        >
          {/* TODO: local tweat, to remove back */}
          {stepIndex === 0 && (
            <AIReviewSourcesPanel setNextDisabled={setNextDisabled} sourceIds={sourceIds} setSourceIds={setSourceIds} sourceRoundIds={sourceRoundIds} setSourceRoundIds={setSourceRoundIds} />
          )}
          {stepIndex === 1 && <AIReviewQuestionsPanel questionIds={questionIds} setQuestionIds={setQuestionIds} />}
          {stepIndex === 2 && <AIReviewRelaxPanel task={task} />}
        </WizardStepWrapper>
      </Box>
    </IssbContainer>
  );
}
